<template>
<div class="animated fadeIn">

  <v-client-table :data="reservations" :columns="columns" :options="options" :theme="theme" id="reservationReservationsTable" ref="reservationReservationsTable">
    <template slot="actions" slot-scope="data">
      <b-button class="mr-1" size="sm" variant="primary" @click="unCheckReservation(data.row)">Uncheck</b-button>
    </template>
    <template slot="created_at" slot-scope="data">
      {{ $moment(data.row.created_at).format('YYYY-MM-DD') }}
    </template>
  </v-client-table>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

export default {
  name: "ReservationSelected",
  props: {
    reservations: Array
  },
  data() {
    return {
      columns: [
        'event_type.name',
        'id_card_no',
        'applicant_name',
        'members.length',
        'created_at',
        'arrival_date',
        'departure_date',
        'actions'
      ],
      options: {
        headings: {
          'event_type.name': 'Bhandara/Satsang',
          id_card_no: 'Id Card (or reason)',
          applicant_name: 'Applicant',
          'members.length': 'Members',
          arrival_date: 'Arrival',
          departure_date: 'Departure',
          actions: 'Actions'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },
  methods: {
    unCheckReservation(reservation) {
      this.$emit('uncheck', reservation.id)
    },

  },
  created() {
  }
}
</script>
